import { IBakerEnv } from './IBakerEnv';

export const environment: IBakerEnv = {
  production: false,
  name: 'baker-dev',
  baseApiUrl: 'https://bakerweb-api-dev.gobakersolutions.com',
  baseLsegUrl: 'https://lseg-dev.gobaker.com',
  graphQLUrl: 'https://graphql-dev.gobakersolutions.com/graphql',
  bbaReportsPublisherUrl: 'https://api.gobaker.com/api/BbaReportsPublisher',
  msal: {
    tenantId: '2b6264c4-065a-4ee2-9c7d-3a15ca28eb67',
    // Baker Portal SPA registration (sign-in identity).
    clientId: '0a86eafc-bb4f-416f-ad33-76c509a16373',
    authority: 'https://login.microsoftonline.com/2b6264c4-065a-4ee2-9c7d-3a15ca28eb67',
    redirectUri: 'https://baker-dev.gobaker.com/',
    postLogoutRedirectUri: 'https://baker-dev.gobaker.com/',
    // Token audience = the Baker Portal registration, addressed by raw client ID so
    // it resolves to the app's service principal without needing an Application ID URI
    // set in Entra. The shared backend accepts this audience via ENTRA_ADDITIONAL_AUDIENCES.
    apiScope: '0a86eafc-bb4f-416f-ad33-76c509a16373/.default'
  }
};
